export default "__VITE_ASSET__BH07_L9B__"